import { useEffect } from "react";

import { useFormikContext } from "formik";

const FocusError = () => {
    const { errors, isSubmitting, isValidating } = useFormikContext();
    useEffect(() => {
      if (isSubmitting && !isValidating) {
        let keys = Object.keys(errors);
        if (keys.length > 0) {
          const selector = `[name=${keys[0]}]`;
          let errorElement = null;
          errorElement = document.querySelector(selector);
          if (!errorElement) {
            errorElement = document.getElementById(keys[0]);
          }
          const yOffset = -350;
          const y =
            errorElement?.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;
          const isSmoothScrollSupported =
            "scrollBehavior" in document.documentElement.style;
          if (isSmoothScrollSupported) {
            window.scrollTo({ top: y, behavior: "smooth" });
          } else {
            document.body.scrollTop = y;
            document.documentElement.scrollTop = y;
          }
          setTimeout(() => {
            errorElement?.focus();
          }, 500);
        }
      }
    }, [errors, isSubmitting, isValidating]);
  
    return null;
  };

  export default FocusError;